import { Image } from 'expo-image';
import { router } from 'expo-router';
import { StyleSheet } from 'react-native';

import { Button, Favicon, Text, YStack, tokens } from '@fhs/ui';
import { useAuthContext } from '@fhs-legacy/frontend/src/state/auth';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';

function RewardsLockup() {
  return (
    <YStack
      style={styles.rewardsLockup}
      accessible
      accessibilityLabel="Firehouse Rewards. Join. Earn. Redeem."
    >
      <Favicon size={60} aria-hidden />
      <Image
        source={require('./rewards-wordmark.png')}
        contentFit="fill"
        style={styles.rewardsWordmark}
        aria-hidden
      />
      <Text weight="bold" style={styles.rewardsTagline}>
        JOIN. EARN. REDEEM.
      </Text>
    </YStack>
  );
}

export function LoggedOutHeader() {
  const { setOriginLocation } = useAuthContext();

  return (
    <YStack style={styles.container}>
      <RewardsLockup />
      <YStack style={styles.callToAction}>
        <Text style={styles.valueCopy}>
          Earn points toward rewards and enjoy member-only perks, including a birthday reward and up
          to $10 off your first order.
        </Text>
        <Button
          size="md"
          accessibilityRole="button"
          accessibilityLabel="Log In or Sign Up"
          hitSlop={4}
          onPress={() => {
            setOriginLocation(routes.account);
            router.push(routes.signInV2);
          }}
          style={styles.loginButton}
        >
          <Button.Text>Log In / Sign Up</Button.Text>
        </Button>
      </YStack>
    </YStack>
  );
}

const styles = StyleSheet.create({
  container: { alignItems: 'center', gap: 12, paddingHorizontal: 8, paddingTop: 16 },
  rewardsLockup: { alignItems: 'center', gap: 12, width: '100%' },
  rewardsWordmark: { height: 31, width: 208 },
  rewardsTagline: { fontFamily: 'HeroSerifBold', fontSize: 16, lineHeight: 19 },
  callToAction: { alignItems: 'center', gap: 24, width: '100%' },
  valueCopy: { fontSize: 14, lineHeight: 20, textAlign: 'center' },
  loginButton: {
    backgroundColor: tokens.colors.$bottomNavigationActive,
    borderColor: tokens.colors.$bottomNavigationActive,
    height: 37,
    width: '100%',
  },
});
